import React from 'react';
import Tooltip, { type TooltipProps } from '@atlaskit/tooltip';

type Props = { isDisabled?: boolean } & TooltipProps;

const ConditionalTooltip = ({ isDisabled, children, ...props }: Props) =>
	isDisabled ? <Tooltip {...props}>{children}</Tooltip> : <>{children}</>;

export default ConditionalTooltip;
